/* eslint-disable */
//#region src/ar-SA.ts
const arSA = {
	locale: "ar-SA",
	actionBlocked: {
		subtitle: void 0,
		title: void 0,
		traceIdLabel: void 0
	},
	apiKeys: {
		action__add: void 0,
		action__search: void 0,
		copySecret: {
			formButtonPrimary__copyAndClose: "نسخ وإغلاق",
			formHint: "لأسباب أمنية، لن نسمح لك بعرضه مرة أخرى لاحقاً.",
			formTitle: "انسخ مفتاح API الخاص بك \"{{name}}\" الآن"
		},
		createdAndExpirationStatus__expiresOn: void 0,
		createdAndExpirationStatus__never: void 0,
		detailsTitle__emptyRow: void 0,
		formButtonPrimary__add: void 0,
		formFieldCaption__expiration__expiresOn: void 0,
		formFieldCaption__expiration__never: void 0,
		formFieldOption__expiration__180d: void 0,
		formFieldOption__expiration__1d: void 0,
		formFieldOption__expiration__1y: void 0,
		formFieldOption__expiration__30d: void 0,
		formFieldOption__expiration__60d: void 0,
		formFieldOption__expiration__7d: void 0,
		formFieldOption__expiration__90d: void 0,
		formFieldOption__expiration__never: void 0,
		formHint: void 0,
		formTitle: void 0,
		lastUsed__days: void 0,
		lastUsed__hours: void 0,
		lastUsed__minutes: void 0,
		lastUsed__months: void 0,
		lastUsed__seconds: void 0,
		lastUsed__years: void 0,
		menuAction__revoke: void 0,
		revokeConfirmation: {
			confirmationText: void 0,
			formButtonPrimary__revoke: void 0,
			formHint: void 0,
			formTitle: void 0,
			inputLabel: void 0
		},
		tableHeader__actions: void 0,
		tableHeader__lastUsed: void 0,
		tableHeader__name: void 0
	},
	backButton: "الرجوع",
	badge__activePlan: void 0,
	badge__banned: void 0,
	badge__canceledEndsAt: void 0,
	badge__currentPlan: void 0,
	badge__default: "الأفتراضي",
	badge__deprovisioned: void 0,
	badge__endsAt: void 0,
	badge__expired: void 0,
	badge__freeTrial: void 0,
	badge__otherImpersonatorDevice: "جهاز منتحل آخر",
	badge__pastDueAt: void 0,
	badge__pastDuePlan: void 0,
	badge__primary: "الرئيسي",
	badge__renewsAt: void 0,
	badge__requiresAction: "الإجراء المطلوب",
	badge__startsAt: void 0,
	badge__thisDevice: "هذا الجهاز",
	badge__trialEndsAt: void 0,
	badge__unverified: "لم يتم التحقق منه",
	badge__upcomingPlan: void 0,
	badge__userDevice: "جهاز المستخدم",
	badge__you: "أنت",
	billing: {
		accountCredit: void 0,
		addPaymentMethod__label: void 0,
		alwaysFree: void 0,
		annually: void 0,
		availableFeatures: void 0,
		billedAnnually: void 0,
		billedAnnuallyOnly: void 0,
		billedMonthly: void 0,
		billedMonthlyOnly: void 0,
		cancelFreeTrial: void 0,
		cancelFreeTrialAccessUntil: void 0,
		cancelFreeTrialTitle: void 0,
		cancelSubscription: void 0,
		cancelSubscriptionAccessUntil: void 0,
		cancelSubscriptionNoCharge: void 0,
		cancelSubscriptionPastDue: void 0,
		cancelSubscriptionTitle: void 0,
		cannotSubscribeMonthly: void 0,
		cannotSubscribeUnrecoverable: void 0,
		checkout: {
			addPromoCode: void 0,
			applyPromoCode: void 0,
			description__paymentSuccessful: void 0,
			description__subscriptionSuccessful: void 0,
			discount: void 0,
			downgradeNotice: void 0,
			emailForm: {
				subtitle: void 0,
				title: void 0
			},
			lineItems: {
				title__freeTrialEndsAt: void 0,
				title__paymentMethod: void 0,
				title__statementId: void 0,
				title__subscriptionBegins: void 0,
				title__totalPaid: void 0
			},
			pastDueNotice: void 0,
			perMonth: void 0,
			promoCodePlaceholder: void 0,
			removePromoCode: void 0,
			title: void 0,
			title__paymentSuccessful: void 0,
			title__subscriptionSuccessful: void 0,
			title__trialSuccess: void 0,
			totalDueAfterTrial: void 0,
			totalDuePerPeriod: void 0
		},
		credit: void 0,
		creditRemainder: void 0,
		defaultFreePlanActive: void 0,
		discountAmount: void 0,
		discountCyclesRemaining: void 0,
		discountDuration: void 0,
		free: void 0,
		getStarted: void 0,
		highlightedPlanBadge: void 0,
		keepFreeTrial: void 0,
		keepSubscription: void 0,
		manage: void 0,
		manageSubscription: void 0,
		month: void 0,
		monthAbbreviation: void 0,
		monthPerUnit: void 0,
		monthly: void 0,
		months: void 0,
		pastDue: void 0,
		pay: void 0,
		payerCreditRemainder: void 0,
		paymentMethod: {
			applePayDescription: {
				annual: void 0,
				monthly: void 0
			},
			dev: {
				anyNumbers: void 0,
				cardNumber: void 0,
				cvcZip: void 0,
				developmentMode: void 0,
				expirationDate: void 0,
				testCardInfo: void 0
			}
		},
		paymentMethods__label: void 0,
		pricingTable: {
			billingCycle: void 0,
			included: void 0,
			seatCost: {
				additionalSeats: void 0,
				freeUpToSeats: void 0,
				includedSeats: void 0,
				perSeat: void 0,
				tooltip: {
					additionalSeatsEach: void 0,
					firstSeatsIncludedInPlan: void 0,
					freeForUpToSeats: void 0
				},
				unlimitedSeats: void 0,
				upToSeats: void 0
			}
		},
		proratedDiscount: void 0,
		prorationCredit: void 0,
		reSubscribe: void 0,
		seatBreakdownIncludedPlural: void 0,
		seatBreakdownIncludedSingular: void 0,
		seatBreakdownPlural: void 0,
		seatBreakdownSingular: void 0,
		seats: void 0,
		seatsWithLimit: void 0,
		seeAllFeatures: void 0,
		startFreeTrial: void 0,
		startFreeTrial__days: void 0,
		subscribe: void 0,
		subscriptionDetails: {
			beginsOn: void 0,
			currentBillingCycle: void 0,
			endsOn: void 0,
			firstPaymentAmount: void 0,
			firstPaymentOn: void 0,
			nextPaymentAmount: void 0,
			nextPaymentOn: void 0,
			pastDueAt: void 0,
			renewsAt: void 0,
			subscribedOn: void 0,
			title: void 0,
			trialEndsOn: void 0,
			trialStartedOn: void 0
		},
		subtotal: void 0,
		subtotalRenewal: void 0,
		switchPlan: void 0,
		switchToAnnual: void 0,
		switchToAnnualWithAnnualPrice: void 0,
		switchToMonthly: void 0,
		switchToMonthlyWithPrice: void 0,
		totalDue: void 0,
		totalDuePerPeriod: void 0,
		totalDueToday: void 0,
		viewFeatures: void 0,
		viewPayment: void 0,
		year: void 0,
		yearAbbreviation: void 0,
		yearPerUnit: void 0,
		years: void 0
	},
	configureDirectorySync: {
		attributeMappingStep: {
			columns: {
				clerkAttribute: void 0,
				directoryAttribute: void 0
			},
			subtitle: void 0,
			title: void 0
		},
		configureStep: {
			actionLabel__generateToken: void 0,
			actionLabel__replaceKey: void 0,
			actionLabel__retry: void 0,
			actionLabel__uploadKey: void 0,
			badge__credentialsConfigured: void 0,
			badge__credentialsMissing: void 0,
			domainsLabel: void 0,
			error__invalidKeyFile: void 0,
			error__ssoRequired: {
				subtitle: void 0,
				title: void 0
			},
			formFieldHint__subjectEmail: void 0,
			formFieldInputPlaceholder__subjectEmail: void 0,
			formFieldInputPlaceholder__token: void 0,
			formFieldLabel__endpointUrl: void 0,
			formFieldLabel__serviceAccountKey: void 0,
			formFieldLabel__subjectEmail: void 0,
			formFieldLabel__token: void 0,
			instructions: {
				actionLabel__toggle: void 0,
				custom: {
					step1: void 0,
					step2: void 0,
					step3: void 0,
					step4: void 0
				},
				entra: {
					step1: void 0,
					step2: void 0,
					step3: void 0,
					step4: void 0
				},
				google: {
					step1: void 0,
					step2: void 0,
					step3: void 0,
					step4: void 0,
					step5: void 0
				},
				okta: {
					step1: void 0,
					step2: void 0,
					step3: void 0,
					step4: void 0
				}
			},
			notice__tokenShownOnce: void 0,
			subtitle: void 0,
			title: void 0,
			warning__ssoInactive: void 0
		},
		navbar: { title: void 0 },
		providers: {
			custom: void 0,
			entra: void 0,
			google: void 0,
			okta: void 0
		},
		roleMappingStep: {
			actionHint__reorder: void 0,
			actionLabel__reorder: void 0,
			alert__missingManageMembersPermission: {
				subtitle: void 0,
				title: void 0
			},
			columns: {
				directoryGroup: void 0,
				priority: void 0,
				role: void 0
			},
			disableDialog: {
				cancelButton: void 0,
				confirmButton: void 0,
				subtitle: void 0,
				title: void 0
			},
			empty__noGroups: {
				subtitle: void 0,
				title: void 0
			},
			enableDialog: {
				cancelButton: void 0,
				confirmButton: void 0,
				subtitle: void 0,
				title: void 0
			},
			error__loadMappings: void 0,
			everyoneElse: void 0,
			formFieldLabel__syncRoles: void 0,
			roleOption__unassigned: void 0,
			subtitle: void 0,
			title: void 0
		},
		stepper: {
			attributes: void 0,
			configure: void 0,
			roles: void 0,
			test: void 0
		},
		testStep: {
			actionLabel__complete: void 0,
			actionLabel__syncNow: void 0,
			badge__active: void 0,
			badge__deprovisioned: void 0,
			description: void 0,
			description__pull: void 0,
			empty__noUsersProvisioned: void 0,
			empty__waitingForFirstSync: void 0,
			empty__waitingForFirstUser: void 0,
			error__lastSyncFailed: void 0,
			error__loadUsers: void 0,
			error__syncFailed: void 0,
			note: void 0,
			noteLabel: void 0,
			subtitle: void 0,
			syncRow: {
				neverSynced: void 0,
				title: void 0
			},
			syncStatus__cancelled: void 0,
			syncStatus__failed: void 0,
			syncStatus__running: void 0,
			syncStatus__succeeded: void 0,
			title: void 0
		}
	},
	configureSSO: {
		activate: {
			activateButton: void 0,
			activeSubtitle: void 0,
			activeTitle: void 0,
			doneButton: void 0,
			skipButton: void 0,
			subtitle: void 0,
			title: void 0
		},
		changeProviderDialog: {
			cancelButton: void 0,
			confirmButton: void 0,
			subtitle: void 0,
			title: void 0
		},
		configureStep: {
			activeConnectionWarning: {
				dismiss: void 0,
				title: void 0
			},
			attributeMappingTable: { badges: {
				optional: void 0,
				required: void 0
			} },
			oidcCustom: {
				credentialsStep: {
					clientId: {
						label: void 0,
						placeholder: void 0
					},
					clientSecret: {
						label: void 0,
						placeholder: void 0
					},
					headerSubtitle: void 0,
					paragraph: void 0
				},
				endpointsStep: {
					discoveryUrl: {
						description: void 0,
						label: void 0,
						placeholder: void 0
					},
					headerSubtitle: void 0,
					manual: {
						authUrl: {
							label: void 0,
							placeholder: void 0
						},
						description: void 0,
						tokenUrl: {
							label: void 0,
							placeholder: void 0
						},
						userInfoUrl: {
							label: void 0,
							placeholder: void 0
						}
					},
					modes: {
						ariaLabel: void 0,
						discoveryUrl: void 0,
						manual: void 0
					}
				},
				mainHeaderTitle: void 0,
				redirectUriStep: {
					claims: {
						description: void 0,
						table: {
							columns: {
								attribute: void 0,
								claim: void 0
							},
							rows: {
								email: { attribute: void 0 },
								firstName: { attribute: void 0 },
								lastName: { attribute: void 0 },
								subject: { attribute: void 0 }
							}
						}
					},
					headerSubtitle: void 0,
					paragraph: void 0,
					redirectUri: { label: void 0 }
				}
			},
			samlCustom: {
				assignUsersStep: {
					headerSubtitle: void 0,
					paragraph: void 0
				},
				attributeMappingStep: {
					attributeMappingTable: {
						columns: {
							attributeName: void 0,
							userAttribute: void 0
						},
						rows: {
							email: {
								attributeName: void 0,
								userAttribute: void 0
							},
							firstName: {
								attributeName: void 0,
								userAttribute: void 0
							},
							lastName: {
								attributeName: void 0,
								userAttribute: void 0
							}
						}
					},
					headerSubtitle: void 0,
					paragraph: void 0
				},
				createAppStep: {
					createAppInstructions: { paragraph: void 0 },
					headerSubtitle: void 0,
					serviceProviderFields: {
						acsUrl: { label: void 0 },
						spEntityId: { label: void 0 }
					}
				},
				identityProviderMetadataStep: {
					headerSubtitle: void 0,
					manual: {
						description: void 0,
						issuer: {
							label: void 0,
							placeholder: void 0
						},
						signOnUrl: {
							label: void 0,
							placeholder: void 0
						},
						signingCertificate: {
							fileUploaded: void 0,
							label: void 0,
							removeFile: void 0,
							replaceFile: void 0,
							uploadFile: void 0
						}
					},
					metadataUrl: {
						description: void 0,
						label: void 0,
						placeholder: void 0
					},
					modes: {
						ariaLabel: void 0,
						manual: void 0,
						metadataUrl: void 0
					}
				},
				mainHeaderTitle: void 0
			},
			samlGoogle: {
				attributeMappingStep: {
					attributeMappingTable: {
						columns: {
							appAttribute: void 0,
							googleAttribute: void 0
						},
						rows: {
							email: {
								appAttribute: void 0,
								googleAttribute: void 0
							},
							firstName: {
								appAttribute: void 0,
								googleAttribute: void 0
							},
							lastName: {
								appAttribute: void 0,
								googleAttribute: void 0
							}
						}
					},
					headerSubtitle: void 0,
					paragraph: void 0,
					step1: void 0,
					step2: void 0
				},
				configureUserAccess: {
					assignUsersInstructions: {
						paragraph1: void 0,
						paragraph2: void 0,
						step1: void 0,
						step2: void 0,
						step3: void 0
					},
					headerSubtitle: void 0
				},
				createAppStep: {
					createAppInstructions: {
						step1: void 0,
						step2: void 0,
						step3: void 0,
						step4: void 0,
						title: void 0
					},
					headerSubtitle: void 0
				},
				identityProviderMetadataStep: {
					headerSubtitle: void 0,
					manual: {
						description: void 0,
						issuer: {
							label: void 0,
							placeholder: void 0
						},
						signOnUrl: {
							label: void 0,
							placeholder: void 0
						},
						signingCertificate: {
							fileUploaded: void 0,
							label: void 0,
							removeFile: void 0,
							replaceFile: void 0,
							uploadFile: void 0
						}
					},
					metadataFile: {
						description: void 0,
						fileUploaded: void 0,
						label: void 0,
						removeFile: void 0,
						replaceFile: void 0,
						uploadFile: void 0
					},
					modes: {
						ariaLabel: void 0,
						manual: void 0,
						metadataFile: void 0
					}
				},
				mainHeaderTitle: void 0,
				serviceProviderStep: {
					headerSubtitle: void 0,
					nameIdInstructions: {
						step1: void 0,
						step2: void 0
					},
					paragraph: void 0,
					serviceProviderFields: {
						acsUrl: { label: void 0 },
						spEntityId: { label: void 0 }
					},
					title: void 0
				}
			},
			samlMicrosoft: {
				attributeMappingStep: {
					attributeMappingTable: {
						columns: {
							attribute: void 0,
							claimName: void 0,
							value: void 0
						},
						copyClaimName: void 0,
						copyClaimNameCopied: void 0,
						rows: {
							email: {
								attribute: void 0,
								claimName: void 0,
								value: void 0
							},
							firstName: {
								attribute: void 0,
								claimName: void 0,
								value: void 0
							},
							lastName: {
								attribute: void 0,
								claimName: void 0,
								value: void 0
							}
						}
					},
					headerSubtitle: void 0,
					step1: void 0,
					step2: void 0,
					title: void 0
				},
				createAppStep: {
					assignUsersInstructions: {
						step1: void 0,
						step2: void 0,
						step3: void 0,
						step4: void 0,
						step5: void 0,
						title: void 0
					},
					createAppInstructions: {
						step1: void 0,
						step2: void 0,
						step3: void 0,
						step4: {
							label: void 0,
							subSteps: {
								appName: void 0,
								create: void 0,
								nonGallery: void 0
							}
						},
						title: void 0
					},
					headerSubtitle: void 0
				},
				identityProviderMetadataStep: {
					headerSubtitle: void 0,
					manual: {
						description: void 0,
						issuer: {
							label: void 0,
							placeholder: void 0
						},
						signOnUrl: {
							label: void 0,
							placeholder: void 0
						},
						signingCertificate: {
							fileUploaded: void 0,
							label: void 0,
							removeFile: void 0,
							replaceFile: void 0,
							uploadFile: void 0
						}
					},
					metadataUrl: {
						description: void 0,
						label: void 0,
						placeholder: void 0
					},
					modes: {
						ariaLabel: void 0,
						manual: void 0,
						metadataUrl: void 0
					}
				},
				mainHeaderTitle: void 0,
				serviceProviderStep: {
					headerSubtitle: void 0,
					serviceProviderFields: {
						acsUrl: { label: void 0 },
						spEntityId: { label: void 0 }
					},
					step1: void 0,
					step2: void 0,
					step3: void 0,
					step4: void 0,
					step5: void 0,
					step6: void 0,
					title: void 0
				}
			},
			samlOkta: {
				assignUsersStep: {
					assignUsersInstructions: {
						paragraph: void 0,
						step1: void 0,
						step2: void 0,
						step3: void 0,
						step4: void 0,
						step5: void 0
					},
					headerSubtitle: void 0
				},
				attributeMappingStep: {
					attributeMappingTable: {
						columns: {
							expression: void 0,
							name: void 0
						},
						rows: {
							email: {
								expression: void 0,
								name: void 0
							},
							firstName: {
								expression: void 0,
								name: void 0
							},
							lastName: {
								expression: void 0,
								name: void 0
							}
						}
					},
					headerSubtitle: void 0,
					paragraph: void 0,
					step1: void 0,
					step2: void 0
				},
				createAppStep: {
					completeSamlIntegrationInstructions: {
						step1: void 0,
						step2: void 0,
						title: void 0
					},
					createAppInstructions: {
						step1: void 0,
						step2: void 0,
						step3: void 0,
						step4: void 0,
						title: void 0
					},
					headerSubtitle: void 0,
					serviceProviderInstructions: {
						paragraph1: void 0,
						paragraph2: void 0,
						serviceProviderFields: {
							acsUrl: { label: void 0 },
							spEntityId: { label: void 0 }
						},
						title: void 0
					}
				},
				identityProviderMetadataStep: {
					headerSubtitle: void 0,
					manual: {
						description: void 0,
						issuer: {
							label: void 0,
							placeholder: void 0
						},
						signOnUrl: {
							label: void 0,
							placeholder: void 0
						},
						signingCertificate: {
							fileUploaded: void 0,
							label: void 0,
							removeFile: void 0,
							replaceFile: void 0,
							uploadFile: void 0
						}
					},
					metadataUrl: {
						description: void 0,
						label: void 0,
						placeholder: void 0
					},
					modes: {
						ariaLabel: void 0,
						manual: void 0,
						metadataUrl: void 0
					}
				},
				mainHeaderTitle: void 0
			},
			unsupportedProvider: {
				description: void 0,
				title: void 0
			}
		},
		connectionScopeBanner: {
			subtitle__adding: void 0,
			subtitle__editing: void 0,
			title__adding: void 0,
			title__editing: void 0
		},
		missingManageEnterpriseConnectionsPermission: {
			subtitle: "تواصل مع مسؤول مؤسستك لترقية أذوناتك.",
			title: "ليس لديك إذن لإدارة تسجيل الدخول الموحد (SSO)"
		},
		navbar: { title: "تكوين تسجيل الدخول الموحد (SSO)" },
		organizationDomainsStep: {
			domainCard: {
				badge__claimed: void 0,
				badge__expired: void 0,
				badge__unverified: "لم يتم التحقق",
				badge__verified: "تم التحقق",
				checkboxLabel: void 0,
				expiredAtLabel: void 0,
				expiredLabel: void 0,
				removeButtonTooltip__lastVerifiedDomain: void 0,
				removeButtonTooltip__lastVerifiedDomainActive: void 0,
				txtRecord: {
					hostLabel: "المضيف / الاسم",
					instructions: "أضِف سجل TXT هذا إلى مزوّد DNS الخاص بك. سنتحقق تلقائيًا بمجرد أن يصبح السجل نشطًا.",
					typeLabel: "النوع",
					valueLabel: "القيمة"
				},
				verifiedAtLabel: "تم التحقق في {{ date | shortDate('en-US') }}",
				verifyAgainButton: void 0
			},
			domainSuggestion: {
				formButtonPrimary__add: "إضافة {{domain}}",
				messageLabel: "بريدك الإلكتروني يستخدم {{domain}}. هل تريد إضافته؟"
			},
			formButtonPrimary__add: "إضافة",
			formFieldInputPlaceholder__domain: "إضافة نطاق",
			formFieldLabel__domain: "النطاق",
			removeDomainDialog: {
				cancelButton: void 0,
				removeButton: void 0,
				subtitle__active: void 0,
				subtitle__inactive: void 0,
				title: void 0
			},
			subtitle: "أضِف نطاقات مؤسستك المستخدمة لتسجيل الدخول وتحقّق من ملكيتها.",
			title: "إضافة نطاقات SSO"
		},
		resetConnectionDialog: {
			cancelButton: void 0,
			confirmationFieldLabel: void 0,
			confirmationFieldPlaceholder: void 0,
			resetButton: void 0,
			subtitle: void 0,
			title: void 0
		},
		selectProviderStep: {
			oidc: {
				groupLabel: void 0,
				oidcProvider: void 0
			},
			saml: {
				customSaml: "مزود SAML مخصص",
				google: void 0,
				groupLabel: "SAML",
				microsoft: void 0,
				okta: "Okta Workforce"
			},
			subtitle: "اختر المزود الذي ستقوم بإعداد تسجيل الدخول الموحد (SSO) له.",
			title: "اختر المزود",
			warning: "بمجرد اختيار المزود لا يمكنك التغيير مرة أخرى حتى انتهاء التكوين"
		},
		signingCertificates: {
			addCertificate: void 0,
			expired: void 0,
			expires: void 0,
			expiryAfterSave: void 0,
			fileUnreadable: void 0,
			notACertificate: void 0,
			primary: void 0,
			primaryTooltip: void 0,
			removeCertificate: void 0
		},
		testConfigurationStep: {
			error__noSuccessfulTestRun: void 0,
			subtitle: void 0,
			testResults: {
				actionLabel__refresh: void 0,
				empty: {
					subtitle: void 0,
					title: void 0
				},
				polling: void 0,
				status__failed: void 0,
				status__pending: void 0,
				status__success: void 0,
				title: void 0
			},
			testRunDetails: {
				howToFix: {
					actionLabel__viewDocumentation: void 0,
					oauth_access_denied: { description: void 0 },
					oauth_fetch_user_error: {
						intro: void 0,
						step1: void 0,
						step2: void 0
					},
					oauth_token_exchange_error: { description: void 0 },
					saml_email_address_domain_mismatch: { description: void 0 },
					saml_response_relaystate_missing: { description: void 0 },
					saml_user_attribute_missing: {
						intro: void 0,
						step1: void 0,
						step2: void 0,
						step3: void 0
					},
					sectionTitle: void 0
				},
				parsedUserInfo: {
					email: void 0,
					firstName: void 0,
					sectionTitle: void 0
				},
				runDetails: {
					actionLabel__copied: void 0,
					actionLabel__copy: void 0,
					errorCode: void 0,
					fullMessage: void 0,
					sectionTitle: void 0,
					status: void 0,
					timestamp: void 0
				},
				title: void 0
			},
			testUrl: { actionLabel__open: void 0 },
			title: void 0
		}
	},
	createOrganization: {
		formButtonSubmit: "أنشاء منظمة",
		invitePage: { formButtonReset: "تخطي" },
		title: "أنشاء منظمة"
	},
	dates: {
		lastDay: "الأمس في {{ date | timeString('en-US') }}",
		next6Days: "{{ date | weekday('en-US','long') }} في {{ date | timeString('en-US') }}",
		nextDay: "غدا في {{ date | timeString('en-US') }}",
		numeric: "{{ date | numeric('en-US') }}",
		previous6Days: "أخر {{ date | weekday('en-US','long') }} في {{ date | timeString('en-US') }}",
		sameDay: "اليوم في {{ date | timeString('en-US') }}"
	},
	dividerText: "أو",
	footerActionLink__alternativePhoneCodeProvider: void 0,
	footerActionLink__useAnotherMethod: "أختر طريقة أخرى",
	footerPageLink__help: "المساعدة",
	footerPageLink__privacy: "الخصوصية",
	footerPageLink__terms: "الشروط",
	formButtonPrimary: "متابعة",
	formButtonPrimary__verify: "تحقق",
	formFieldAction__forgotPassword: "نسيت كلمة المرور؟",
	formFieldAction__hidePassword: "إخفاء كلمة المرور",
	formFieldAction__showPassword: "إظهار كلمة المرور",
	formFieldError__matchingPasswords: "كلمة المرور مطابقة",
	formFieldError__notMatchingPasswords: "كلمة المرور لا تتطابق",
	formFieldError__verificationLinkExpired: "صلاحية رمز التأكيد أنتهت. يرجى طلب رابط جديد",
	formFieldHintText__optional: "إختياري",
	formFieldHintText__slug: "(slug) هو معرف يمكن قراءته بواسطة الإنسان ويجب أن يكون فريدًا. غالبًا ما يتم استخدامه في الروابط الإلكترونية.",
	formFieldInputPlaceholder__apiKeyDescription: void 0,
	formFieldInputPlaceholder__apiKeyExpirationDate: void 0,
	formFieldInputPlaceholder__apiKeyName: void 0,
	formFieldInputPlaceholder__backupCode: void 0,
	formFieldInputPlaceholder__confirmDeletionUserAccount: "حذف الحساب",
	formFieldInputPlaceholder__emailAddress: void 0,
	formFieldInputPlaceholder__emailAddress_username: void 0,
	formFieldInputPlaceholder__emailAddresses: "أدخل أو لصق عنوان بريد إلكتروني واحد أو أكثر ، مفصولة بمسافات أو فواصل",
	formFieldInputPlaceholder__firstName: void 0,
	formFieldInputPlaceholder__lastName: void 0,
	formFieldInputPlaceholder__organizationDomain: void 0,
	formFieldInputPlaceholder__organizationDomainEmailAddress: void 0,
	formFieldInputPlaceholder__organizationName: void 0,
	formFieldInputPlaceholder__organizationSlug: void 0,
	formFieldInputPlaceholder__password: void 0,
	formFieldInputPlaceholder__phoneNumber: void 0,
	formFieldInputPlaceholder__signUpPassword: void 0,
	formFieldInputPlaceholder__username: void 0,
	formFieldInput__emailAddress_format: void 0,
	formFieldLabel__apiKey: "مفتاح API",
	formFieldLabel__apiKeyDescription: "الوصف",
	formFieldLabel__apiKeyExpiration: "الانتهاء",
	formFieldLabel__apiKeyName: "اسم المفتاح السري",
	formFieldLabel__automaticInvitations: "تمكين الدعوة الأوتماتكية لهذا النطاق",
	formFieldLabel__backupCode: "الرمز الأحتياطي",
	formFieldLabel__confirmDeletion: "تأكيد",
	formFieldLabel__confirmPassword: "تأكيد كلمة المرور",
	formFieldLabel__currentPassword: "كلمة المرور الحالية",
	formFieldLabel__emailAddress: "العنوان الإلكتروني",
	formFieldLabel__emailAddress_username: "العنوان الإلكتروني أو اسم المستخدم",
	formFieldLabel__emailAddresses: "العناوين الإلكترونية",
	formFieldLabel__firstName: "الاسم الأول",
	formFieldLabel__lastName: "الاسم الأخير",
	formFieldLabel__newPassword: "كلمة المرور الجديدة",
	formFieldLabel__organizationDomain: "النطاق",
	formFieldLabel__organizationDomainDeletePending: "حذف الدعوات والأقتراحات المعلقة",
	formFieldLabel__organizationDomainEmailAddress: "عنوان البريد الإلكتروني للتحقق",
	formFieldLabel__organizationDomainEmailAddressDescription: "أدخل البريد الإلكتروني الخاص بالنطاق للحصول على  الرمز والتحقق من النطاق",
	formFieldLabel__organizationName: "اسم المنظمة",
	formFieldLabel__organizationSlug: "رابط المنظمة",
	formFieldLabel__passkeyName: "اسم مفتاح المرور (Passkey)",
	formFieldLabel__password: "كلمة المرور",
	formFieldLabel__phoneNumber: "رقم الجوال",
	formFieldLabel__role: "دور",
	formFieldLabel__signOutOfOtherSessions: "تسجيل الخروج من جميع الأجهزة",
	formFieldLabel__username: "اسم المستخدم",
	identityPreviewEditButton__emailAddress: void 0,
	identityPreviewEditButton__identifier: void 0,
	identityPreviewEditButton__phoneNumber: void 0,
	impersonationFab: {
		action__signOut: "تسجيل الخروج",
		title: "تسجيل الدخول بأسم {{identifier}}"
	},
	lastAuthenticationStrategy: "آخر استخدام",
	maintenanceMode: "نحن نقوم بعمل بعض التعديلات في الوقت الحالي. سوف نعود في غضون دقائق قليلة",
	membershipRole__admin: "المسؤول",
	membershipRole__basicMember: "عضو",
	membershipRole__guestMember: "ضيف",
	oauthConsent: {
		action__allow: void 0,
		action__deny: void 0,
		offlineAccessNotice: void 0,
		redirectNotice: void 0,
		redirectUriModal: {
			subtitle: void 0,
			title: void 0
		},
		scopeList: {
			privateMetadata: void 0,
			title: void 0
		},
		subtitle: void 0,
		viewFullUrl: void 0,
		warning: void 0
	},
	oauthDeviceVerification: {
		action__tryAnotherCode: void 0,
		confirmation: {
			action__approve: void 0,
			action__deny: void 0,
			scopeListTitle: void 0,
			subtitle: void 0,
			title: void 0,
			warning: void 0
		},
		error: {
			expiredSubtitle: void 0,
			expiredTitle: void 0,
			genericSubtitle: void 0,
			genericTitle: void 0,
			invalidCode: void 0,
			rateLimitedSubtitle: void 0,
			rateLimitedTitle: void 0,
			unknownCode: void 0
		},
		start: {
			action__continue: void 0,
			subtitle: void 0,
			title: void 0,
			userCodeLabel: void 0
		},
		status: {
			alreadyApprovedSubtitle: void 0,
			alreadyApprovedTitle: void 0,
			alreadyDecidedSubtitle: void 0,
			alreadyDecidedTitle: void 0,
			alreadyDeniedSubtitle: void 0,
			alreadyDeniedTitle: void 0,
			approvedSubtitle: void 0,
			approvedTitle: void 0,
			consumedSubtitle: void 0,
			consumedTitle: void 0,
			deniedSubtitle: void 0,
			deniedTitle: void 0
		}
	},
	organizationList: {
		action__createOrganization: "أنشاء منظمة",
		action__invitationAccept: "أنضمام",
		action__suggestionsAccept: "طلب أنضمام",
		createOrganization: "أنشاء منظمة",
		invitationAcceptedLabel: "أنضميت",
		subtitle: "للمتابعة إلى {{applicationName}}",
		suggestionsAcceptedLabel: "موافقة معلقة",
		title: "أختر حساب",
		titleWithoutPersonal: "أختر منظمة"
	},
	organizationProfile: {
		apiKeysPage: { title: void 0 },
		badge__automaticInvitation: "دعوات تلقائية",
		badge__automaticSuggestion: "أقتراحات تلقائية",
		badge__enterpriseSso: void 0,
		badge__manualInvitation: "ليس هناك تسجيل تلقائي",
		badge__unverified: "لم يتم التحقق منها",
		billingPage: {
			accountCreditsSection: {
				title: void 0,
				viewHistory: void 0
			},
			creditHistoryPage: {
				tableHeader__amount: void 0,
				tableHeader__date: void 0,
				title: void 0
			},
			paymentHistorySection: {
				empty: void 0,
				notFound: void 0,
				tableHeader__amount: void 0,
				tableHeader__date: void 0,
				tableHeader__status: void 0
			},
			paymentMethodsSection: {
				actionLabel__default: void 0,
				actionLabel__remove: void 0,
				add: void 0,
				addSubtitle: void 0,
				cancelButton: void 0,
				formButtonPrimary__add: void 0,
				formButtonPrimary__pay: void 0,
				payWithTestCardButton: void 0,
				removeMethod: {
					messageLine1: void 0,
					messageLine2: void 0,
					successMessage: void 0,
					title: void 0
				},
				title: void 0
			},
			start: {
				headerTitle__payments: void 0,
				headerTitle__plans: void 0,
				headerTitle__statements: void 0,
				headerTitle__subscriptions: void 0
			},
			statementsSection: {
				empty: void 0,
				itemCaption__paidForPlan: void 0,
				itemCaption__payerCredit: void 0,
				itemCaption__proratedCredit: void 0,
				itemCaption__subscribedAndPaidForPlan: void 0,
				notFound: void 0,
				tableHeader__amount: void 0,
				tableHeader__date: void 0,
				title: void 0,
				totalPaid: void 0
			},
			subscriptionsListSection: {
				actionLabel__manageSubscription: void 0,
				actionLabel__newSubscription: void 0,
				actionLabel__switchPlan: void 0,
				includedSeatsUsage: void 0,
				overview: void 0,
				paidSeatsUsage: void 0,
				seatLimit: void 0,
				seatLimitAndIncludedSeats: void 0,
				tableHeader__edit: void 0,
				tableHeader__plan: void 0,
				tableHeader__startDate: void 0,
				title: void 0
			},
			subscriptionsSection: { actionLabel__default: void 0 },
			switchPlansSection: { title: void 0 },
			title: void 0
		},
		createDomainPage: {
			subtitle: "أضف النطاق للتحقق. المستخدمين الذين لديهم عناوين بريد إلكتروني على هذا النطاق يمكنهم تسجيل الدخول إلى المنظمة بشكل تلقائي أو طلب الأنضمام.",
			title: "إضافة نطاق"
		},
		invitePage: {
			detailsTitle__inviteFailed: "لا يمكن إرسال الدعوات. انظر لتفاصيل المشكلة وحاول مرة أخرى:",
			formButtonPrimary__continue: "إرسال الدعوات",
			formButtonPrimary__purchaseSeats: void 0,
			selectDropdown__role: "إختر دور",
			subtitle: "دعوة أعضاء جدد لهذه المنظمة",
			successMessage: "تم إرسال الدعوات بنجاح",
			title: "دعوة أعضاء"
		},
		membersPage: {
			action__invite: "دعوة",
			action__search: void 0,
			activeMembersTab: {
				menuAction__remove: "إزالة عضو",
				tableHeader__actions: void 0,
				tableHeader__joined: "انضم",
				tableHeader__role: "دور",
				tableHeader__user: "مستخدم"
			},
			alerts: { roleSetMigrationInProgress: {
				subtitle: "نحن نقوم بتحديث الأدوار المتاحة. بمجرد الانتهاء، ستتمكن من تحديث الأدوار مرة أخرى.",
				title: "الأدوار مقفلة مؤقتًا"
			} },
			detailsTitle__emptyRow: "لا يوجد أعضاء للعرض",
			invitationsTab: {
				autoInvitations: {
					headerSubtitle: "قم بدعوة المستخدمين عن طريق توصيل نطاق بريد إلكتروني بمنظمتك. سيتمكن أي شخص يقوم بالتسجيل في مجال بريد إلكتروني مطابق من الانضمام إلى المنظمة في أي وقت.",
					headerTitle: "الدعوات التلقائية",
					primaryButton: "أدارة النطاقات الموثوقة"
				},
				table__emptyRow: "لا دعوات للعرض"
			},
			invitedMembersTab: {
				menuAction__revoke: "سحب الدعوة",
				tableHeader__invited: "مدعو"
			},
			requestsTab: {
				autoSuggestions: {
					headerSubtitle: "سيتمكن المستخدمون الذين يشتركون في مجال بريد إلكتروني مطابق من رؤية اقتراح لطلب الانضمام إلى المنظمة.",
					headerTitle: "اقتراحات تلقائية",
					primaryButton: "إدارة النطاقات التي تم التحقق منها"
				},
				menuAction__approve: "قبول",
				menuAction__reject: "رفض",
				tableHeader__requested: "طلب الأنضمام",
				table__emptyRow: "لا توجد طلبات للعرض"
			},
			start: {
				headerTitle__invitations: "الدعوات",
				headerTitle__members: "الأعضاء",
				headerTitle__requests: "الطلبات"
			}
		},
		navbar: {
			apiKeys: void 0,
			billing: void 0,
			description: "إدارة منظمتك.",
			general: "عام",
			members: "الأعضاء",
			security: void 0,
			title: "المنظمة"
		},
		plansPage: {
			alerts: {
				noPermissionsToManageBilling: void 0,
				planMembershipLimitExceeded: void 0
			},
			title: void 0
		},
		profilePage: {
			dangerSection: {
				deleteOrganization: {
					actionDescription: "أكتب {{organizationName}} بالأسفل للمتابعة.",
					messageLine1: "هل أنت متأكد من انك تريد حذف هذه المنظمة",
					messageLine2: "هذا القرار نهائي ولا يمكن التراجع عنه.",
					successMessage: "لقد حذفت هذه المنظمة",
					title: "حذف المنظمة"
				},
				leaveOrganization: {
					actionDescription: "أكتب {{organizationName}} للمتابعة",
					messageLine1: "هل أنت متاكد أنك تريد الخروج من المنظمة؟ سوف تفقد الصلاحيات لهذه المنظمة وجميع تطبيقاتها",
					messageLine2: "هذا القرار نهائي ولا يمكن التراجع عنه.",
					successMessage: "لقد غادرت المنظمة",
					title: "الخروج من المنظمة"
				},
				title: "خطر"
			},
			domainSection: {
				menuAction__manage: "إدارة",
				menuAction__remove: "حذف",
				menuAction__verify: "تحقق",
				primaryButton: "أضافة نطاق",
				subtitle: "السماح للمستخدمين للأنضمام للمنظمة بشكل تلقائي أو عن طريق دعوة للأنضمام على نطاق بريد إلكتروني تم التحقق منه",
				title: "النطاقات التي تم التحقق منها"
			},
			successMessage: "تم تحديث معلومات المنظمة",
			title: "الملف الشخصي للمنظمة"
		},
		removeDomainPage: {
			messageLine1: "سيتم حذف نطاق البريد الإلكتروني هذا{{domain}}.",
			messageLine2: "لن يتمكن المستخدمون من الانضمام إلى المؤسسة تلقائيًا بعد ذلك.",
			successMessage: "تم حذف هذا النطاق {{domain}}.",
			title: "حذف النطاق"
		},
		securityPage: {
			connectionPage: {
				actions: {
					activate: void 0,
					continueSetup: void 0
				},
				dangerZone: {
					deactivateButton: void 0,
					removeButton: void 0,
					title: void 0
				},
				domains: { title: void 0 },
				identityProvider: {
					certificateExpires: void 0,
					certificates: void 0,
					certificatesCount: void 0,
					certificatesSummary: void 0,
					certificatesSummaryExpired: void 0,
					clientSecret: { placeholder: void 0 },
					editButton: void 0,
					form: { title: void 0 },
					title: void 0
				},
				name: {
					editButton: void 0,
					form: { title: void 0 },
					title: void 0
				},
				serviceProvider: {
					acsUrl: void 0,
					entityId: void 0,
					metadataUrl: void 0,
					redirectUri: void 0,
					title: void 0
				},
				settings: {
					allowAdditionalIdentifiers: {
						description: void 0,
						label: void 0
					},
					allowIdpInitiated: {
						description: void 0,
						label: void 0
					},
					allowSubdomains: {
						description: void 0,
						label: void 0
					},
					forceAuthn: {
						description: void 0,
						label: void 0
					},
					syncUserAttributes: {
						description: void 0,
						label: void 0
					},
					title: void 0
				}
			},
			directorySyncSection: {
				badge__active: void 0,
				badge__inactive: void 0,
				badge__ssoRequired: void 0,
				description: void 0,
				error__load: void 0,
				menuAction__activate: void 0,
				menuAction__deactivate: void 0,
				menuAction__edit: void 0,
				menuAction__remove: void 0,
				primaryButton__configure: void 0,
				removeDialog: {
					confirmButton: void 0,
					subtitle: void 0,
					title: void 0
				},
				title: void 0
			},
			removeDialog: {
				confirmButton: void 0,
				subtitle: void 0,
				title: void 0
			},
			ssoBypassPage: {
				action__add: void 0,
				action__search: void 0,
				addForm: {
					emailPlaceholder: void 0,
					error__allAlreadyAdded: void 0,
					error__alreadyAdded: void 0,
					error__memberNotFound: void 0,
					modeLabel: void 0,
					mode__email: void 0,
					mode__role: void 0,
					roleOption: void 0,
					roleWarning: void 0,
					submitButton: void 0,
					subtitle: void 0,
					title: void 0
				},
				bulkResult: {
					added: void 0,
					addedMember: void 0,
					added__one: void 0,
					domainNotServed: void 0,
					domainNotServed__one: void 0,
					notMember: void 0,
					notMember__one: void 0,
					unknown: void 0,
					unknown__one: void 0
				},
				table: {
					emptyState: void 0,
					emptyState__search: void 0,
					header__actions: void 0,
					header__user: void 0,
					menuAction__remove: void 0
				},
				title: void 0
			},
			ssoBypassSection: {
				allowlistCount: void 0,
				allowlistCount__one: void 0,
				allowlistLabel: void 0,
				description: void 0,
				error__load: void 0,
				menuAction__manage: void 0,
				title: void 0
			},
			ssoSection: {
				badge__active: void 0,
				badge__inProgress: void 0,
				badge__inactive: void 0,
				badge__unconfigured: void 0,
				descriptionLine1: void 0,
				domainLabel: void 0,
				menuAction__activate: void 0,
				menuAction__continue: void 0,
				menuAction__deactivate: void 0,
				menuAction__edit: void 0,
				menuAction__remove: void 0,
				primaryButton__addConnection: void 0,
				primaryButton__configure: void 0,
				primaryButton__continueConfiguration: void 0,
				primaryButton__startConfiguration: void 0,
				title: void 0,
				tooltip: void 0,
				tooltipLabel: void 0,
				tooltip__noRole: void 0
			},
			title: void 0
		},
		start: {
			headerTitle__general: "عام",
			headerTitle__members: "الأعضاء",
			membershipSeatUsageLabel: void 0,
			profileSection: {
				primaryButton: "تحديث الملف الشخصي",
				title: "ملف المنظمة",
				uploadAction__title: "شعار"
			}
		},
		verifiedDomainPage: {
			dangerTab: {
				calloutInfoLabel: "حذف هذا النطاق سيؤثر على المستخدمين المدعوين",
				removeDomainActionLabel__remove: "حذف النطاق",
				removeDomainSubtitle: "حذف هذا النطاق من من النطاقات المعتمدة",
				removeDomainTitle: "حذف النطاق"
			},
			enrollmentTab: {
				automaticInvitationOption__description: "تتم دعوة المستخدمين تلقائيًا للانضمام إلى المؤسسة عند تسجيل حساب جديد ويمكنهم الانضمام في أي وقت.",
				automaticInvitationOption__label: "الدعوات التلقائية",
				automaticSuggestionOption__description: "يتلقى المستخدمون اقتراحًا لطلب الانضمام ، ولكن يجب أن يوافق عليه المشرف قبل أن يتمكنوا من الانضمام إلى المنظمة.",
				automaticSuggestionOption__label: "اقتراحات تلقائية",
				calloutInfoLabel: "إن تغيير وضع التسجيل سيؤثر فقط على المستخدمين الجدد.",
				calloutInvitationCountLabel: "هناك {{count}} دعوة معلقة مرسلة إلى المستخدمين",
				calloutSuggestionCountLabel: "هناك {{count}} أقتراح معلق مرسلة إلى المستخدمين",
				manualInvitationOption__description: "يمكن دعوة المستخدمين يدويًا فقط للمؤسسة.",
				manualInvitationOption__label: "لا يوجد تسجيل تلقائي",
				subtitle: "أختر كيف يمكن للمستخدمين في هذا النطاق تسجيل الدخول إلى المنظمة"
			},
			start: {
				headerTitle__danger: "خطر",
				headerTitle__enrollment: "خيارات التسجيل"
			},
			subtitle: "هذا النطاق {{domain}} موثوق الآن. يمكنك المتابعة وأختيار وضع التسجيل.",
			title: "Update {{domain}}"
		},
		verifyDomainPage: {
			formSubtitle: "أدخل رمز التحقق المرسل إلى بريدك الإلكتروني",
			formTitle: "رمز التحقق",
			resendButton: "لم يصلك الرمز؟ حاول مرة أخرى",
			subtitle: "يجب التحقق من هذا النطاق {{domainName}} عن طريق بريد إلكتروني موثوق",
			subtitleVerificationCodeScreen: "تم إرسال رمز تحقق إلى {{emailAddress}}. أدخل الرمز للمتابعة.",
			title: "التحقق من النطاق"
		}
	},
	organizationSwitcher: {
		action__closeOrganizationSwitcher: void 0,
		action__createOrganization: "أنشاء منظمة",
		action__invitationAccept: "أنضمام",
		action__manageOrganization: "أدارة المنظمة",
		action__openOrganizationSwitcher: void 0,
		action__suggestionsAccept: "طلب أنضمام",
		notSelected: "لم يتم أختيار منظمة",
		personalWorkspace: "الحساب الشخصي",
		suggestionsAcceptedLabel: "موافقة معلقة"
	},
	paginationButton__next: "التالي",
	paginationButton__previous: "السابق",
	paginationRowText__displaying: "عرض",
	paginationRowText__of: "من",
	reverification: {
		alternativeMethods: {
			actionLink: void 0,
			actionText: void 0,
			blockButton__backupCode: void 0,
			blockButton__emailCode: void 0,
			blockButton__passkey: void 0,
			blockButton__password: void 0,
			blockButton__phoneCode: void 0,
			blockButton__totp: void 0,
			getHelp: {
				blockButton__emailSupport: void 0,
				content: void 0,
				title: void 0
			},
			subtitle: void 0,
			title: void 0
		},
		backupCodeMfa: {
			subtitle: void 0,
			title: void 0
		},
		emailCode: {
			formTitle: void 0,
			resendButton: void 0,
			subtitle: void 0,
			title: void 0
		},
		noAvailableMethods: {
			message: void 0,
			subtitle: void 0,
			title: void 0
		},
		passkey: {
			blockButton__passkey: void 0,
			subtitle: void 0,
			title: void 0
		},
		password: {
			actionLink: void 0,
			subtitle: void 0,
			title: void 0
		},
		phoneCode: {
			formTitle: void 0,
			resendButton: void 0,
			subtitle: void 0,
			title: void 0
		},
		phoneCodeMfa: {
			formTitle: void 0,
			resendButton: void 0,
			subtitle: void 0,
			title: void 0
		},
		totpMfa: {
			formTitle: void 0,
			subtitle: void 0,
			title: void 0
		}
	},
	searchInput: { action__clear: void 0 },
	signIn: {
		accountSwitcher: {
			action__addAccount: "إضافة حساب",
			action__signOutAll: "تسجيل الخروج من جميع الحسابات",
			subtitle: "قم بإختيار الحساب الذي تريد المتابعة به",
			title: "إختر حساب"
		},
		alternativeMethods: {
			actionLink: "الحصول على المساعدة",
			actionText: "لا تملك اي من هؤلاء?",
			blockButton__backupCode: "استخدم رمز النسخ الاحتياطي",
			blockButton__emailCode: "رمز البريد الإلكتروني ل  {{identifier}}",
			blockButton__emailLink: "رابط البريد الإلكتروني ل {{identifier}}",
			blockButton__passkey: "تسجيل الدخول بمفتاح المرور الخاص بك",
			blockButton__password: "تسجيل الدخول بكلمة السر الخاصة بك",
			blockButton__phoneCode: "أرسال رسالة نصية ل{{identifier}}",
			blockButton__totp: "استخدم تطبيق المصادقة الخاص بك",
			getHelp: {
				blockButton__emailSupport: "بريد الدعم الفني",
				content: "إذا كنت تواجه صعوبة في تسجيل الدخول إلى حسابك ، راسلنا عبر البريد الإلكتروني وسنعمل معك لاستعادة الوصول في أقرب وقت ممكن.",
				title: "الحصول على المساعدة"
			},
			subtitle: "تواجه مشكلة؟ تستطيع استخدام أي من هذه الطرق لتسجيل الدخول",
			title: "أستخدام طريقة أخرى"
		},
		alternativePhoneCodeProvider: {
			formTitle: void 0,
			resendButton: void 0,
			subtitle: void 0,
			title: void 0
		},
		backupCodeMfa: {
			subtitle: "للمتابعة إلى {{applicationName}}",
			title: "أدخل الرمز الأحتياطي"
		},
		emailCode: {
			formTitle: "رمز التحقق",
			resendButton: "لم يصلك اي رمز؟ حاول مرة أخرى.",
			subtitle: "للمتابعة إلى {{applicationName}}",
			title: "التحقق من البريد الإلكتروني"
		},
		emailCodeMfa: {
			formTitle: "التحقق من البريد الإلكتروني",
			resendButton: "لم يصلك اي رمز؟ حاول مرة أخرى.",
			subtitle: "للمتابعة إلى {{applicationName}}",
			title: "التحقق من البريد الإلكتروني"
		},
		emailLink: {
			clientMismatch: {
				subtitle: "للمتابعة, قم بفتح رابط التحقق عبر نفس الجهاز والمتصفح الذي انشأت محاولة تسجيل الدخول منه",
				title: "رابط التحقق غير صالح على هذا الجهاز"
			},
			expired: {
				subtitle: "ارجع إلى علامة التبويب الرئيسية للمتابعة.",
				title: "انتهت صلاحية رابط التحقق هذا."
			},
			failed: {
				subtitle: "ارجع إلى علامة التبويب الرئيسية للمتابعة.",
				title: "رابط التحقق هذا غير صالح"
			},
			formSubtitle: "أستعمل رابط التحقق المرسل إلى بريدك الإلكتروني",
			formTitle: "رابط التحقق",
			loading: {
				subtitle: "ستتم إعادة توجيهك قريبًا",
				title: "تسجيل الدخول..."
			},
			resendButton: "لم يصلك الرابط؟ حاول مرة أخرى",
			subtitle: "للمتابعة إلى {{applicationName}}",
			title: "التحقق من البريد الإلكتروني",
			unusedTab: { title: "يمكنك أغلاق هذه النافذة" },
			verified: {
				subtitle: "سيتم أعادة توجيهك في لحظات",
				title: "تم تسجيل الحساب بنجاح"
			},
			verifiedSwitchTab: {
				subtitle: "ارجع إلى علامة التبويب الرئيسية للمتابعة",
				subtitleNewTab: "ارجع إلى علامة التبويب المفتوحة حديثًا للمتابعة",
				titleNewTab: "تم تسجيل الدخول في علامة تبويب أخرى"
			},
			verifiedTransferable: {
				subtitle: void 0,
				title: void 0
			}
		},
		emailLinkMfa: {
			formSubtitle: "استخدم رابط التحقق المرسل إلى بريدك الإلكتروني",
			resendButton: "لم تستلم الرابط؟ إعادة الإرسال",
			subtitle: "للمتابعة إلى {{applicationName}}",
			title: "تحقق من بريدك الإلكتروني"
		},
		enterpriseConnections: {
			subtitle: void 0,
			title: void 0
		},
		enterpriseSSO: { formButtonPrimary: void 0 },
		forgotPassword: {
			formTitle: "رمز تحقق لإعادة تعيين كلمة المرور",
			resendButton: "لم يصلك أي رمز؟ حاول مرة أخرى.",
			subtitle: "لأعادة تعيين كلمة المرور",
			subtitle_email: "أولاً, قم بإدخال الرمز المرسل إلى الايميل الخاص بك",
			subtitle_phone: "أولاً, قم بإدخال الرمز المرسل إلى رقم الهاتف الخاص بك",
			title: "إعادة تعيين كلمة المرور"
		},
		forgotPasswordAlternativeMethods: {
			blockButton__resetPassword: "إعادة تعيين كلمة المرور",
			label__alternativeMethods: "أو سجل الدخول بطريقة أخرى",
			title: "نسيت كلمة المرور؟"
		},
		newDeviceVerificationNotice: "أنت تسجل الدخول من جهاز جديد. نحن نطلب التحقق للحفاظ على أمان حسابك.",
		noAvailableMethods: {
			message: "لا يمكن متابعة تسجيل الدخول. لا يوجد وسيلة مصادقة متاحة.",
			subtitle: "حدث خطأ",
			title: "لا يمكن تسجيل الدخول"
		},
		passkey: {
			subtitle: "يؤدي استخدام مفتاح المرور الخاص بك إلى تأكيد هويتك. جهازك الخاص قد يقوم بسؤالك عن بصمة الإصبع, او معرف الوجة او كلمة مرور قفل الشاشة",
			title: "إستخدم مفتاح المرور"
		},
		password: {
			actionLink: "أستعمل طريقة أخرى",
			subtitle: "للمتابعة إلى {{applicationName}}",
			title: "ادخل كلمة المرور"
		},
		passwordCompromised: { title: void 0 },
		passwordPwned: { title: "كلمة المرور غير آمنة" },
		passwordUntrusted: { title: void 0 },
		phoneCode: {
			formTitle: "رمز التحقق",
			resendButton: "لم يصلك الرمز؟ حاول مرة أخرى",
			subtitle: "للمتابعة إلى {{applicationName}}",
			title: "تحقق من هاتفك"
		},
		phoneCodeMfa: {
			formTitle: "رمز التحقق",
			resendButton: "لم يصلك الرمز؟ حاول مرة أخرى",
			subtitle: "للمتابعة، يرجى إدخال رمز التحقق المرسل إلى هاتفك",
			title: "تحقق من هاتفك"
		},
		protectCheck: {
			loading: void 0,
			retryButton: void 0,
			subtitle: void 0,
			title: void 0
		},
		resetPassword: {
			formButtonPrimary: "أعادة تعيين كلمة المرور",
			requiredMessage: "يوجد حساب بالفعل بهذا البريد الإلكتروني لم يتم التحقق منه. الرجاء أعادة تعيين كلمة المرور لتأمين حسابك",
			successMessage: "تم تغيير كلمة المرور بنجاح. يتم تسجيل الدخول الرجاء الأنتظار قليلا.",
			title: "أعادة تعيين كلمة المرور"
		},
		resetPasswordMfa: { detailsLabel: "نريد التحقق من هويتك قبل أعادة تعيين كلمة المرور" },
		ssoBypass: {
			actionLink: void 0,
			code: {
				resendButton: void 0,
				subtitle: void 0,
				title: void 0
			},
			notice: void 0
		},
		start: {
			actionLink: "إنشاء حساب جديد",
			actionLink__join_waitlist: void 0,
			actionLink__use_email: "استخدم البريد الإلكتروني",
			actionLink__use_email_username: "استخدم البريد الإلكتروني أو اسم المستخدم",
			actionLink__use_passkey: "استخدم مفتاح المرور بدلاً من ذلك",
			actionLink__use_phone: "استخدم رقم الجوال",
			actionLink__use_username: "استخدم اسم المستخدم",
			actionText: "ليس لديك حساب؟",
			actionText__join_waitlist: void 0,
			alternativePhoneCodeProvider: {
				actionLink: void 0,
				label: void 0,
				subtitle: void 0,
				title: void 0
			},
			subtitle: "للمتابعة إلى {{applicationName}}",
			subtitleCombined: "للمتابعة إلى {{applicationName}}",
			title: "تسجيل الدخول",
			titleCombined: void 0
		},
		totpMfa: {
			formTitle: "رمز التحقق",
			subtitle: "للمتابعة، يرجى إدخال رمز التحقق الذي تم إنشاؤه بواسطة تطبيق المصادقة الخاص بك",
			title: "نظام التحقق بخطوتين"
		},
		web3Solana: {
			subtitle: "حدد محفظة أدناه لتسجيل الدخول",
			title: "تسجيل الدخول باستخدام Solana"
		}
	},
	signInEnterPasswordTitle: "إدخل كلمة المرور",
	signUp: {
		alternativePhoneCodeProvider: {
			resendButton: void 0,
			subtitle: void 0,
			title: void 0
		},
		continue: {
			actionLink: "تسجيل الدخول",
			actionText: "ليس لديك حساب؟",
			subtitle: "للمتابعة إلى {{applicationName}}",
			title: "املأ الحقول المفقودة"
		},
		emailCode: {
			formSubtitle: "أدخل رمز التحقق المرسل إلى بريدك الإلكتروني",
			formTitle: "رمز التحقق",
			resendButton: "لم يصلك الرمز؟ حاول مرة أخرى",
			subtitle: "للمتابعة إلى {{applicationName}}",
			title: "تحقق من بريدك الإلكتروني"
		},
		emailLink: {
			clientMismatch: {
				subtitle: "للمتابعة، افتح رابط التحقق على الجهاز والمتصفح الذي أنشأت محاولة عملية التسجيل منه",
				title: "رابط التحقق غير صالح على هذا الجهاز"
			},
			formSubtitle: "أستعمل رابط التحقق المرسل إلى بريدك الإلكتروني",
			formTitle: "رابط التحقق",
			loading: { title: "إنشاء حساب..." },
			resendButton: "لم يصلك الرابط؟ حاول مرة أخرى",
			subtitle: "للمتابعة إلى {{applicationName}}",
			title: "التحقق من البريد الإلكتروني",
			verified: { title: "تم تسجيل الحساب بنجاح" },
			verifiedSwitchTab: {
				subtitle: "ارجع إلى علامة التبويب المفتوحة حديثًا للمتابعة",
				subtitleNewTab: "ارجع إلى علامة التبويب السابقة للمتابعة",
				title: "تم التحقق بنجاح من البريد الإلكتروني"
			}
		},
		enterpriseConnections: {
			subtitle: void 0,
			title: void 0
		},
		legalConsent: {
			checkbox: {
				label__onlyPrivacyPolicy: void 0,
				label__onlyTermsOfService: void 0,
				label__termsOfServiceAndPrivacyPolicy: void 0
			},
			continue: {
				subtitle: void 0,
				title: void 0
			}
		},
		phoneCode: {
			formSubtitle: "أدخل رمز التحقق المرسل إلى هاتفك",
			formTitle: "رمز التحقق",
			resendButton: "لم يصلك الرمز؟ حاول مرة أخرى",
			subtitle: "للمتابعة إلى {{applicationName}}",
			title: "تحقق من هاتفك"
		},
		protectCheck: {
			loading: void 0,
			retryButton: void 0,
			subtitle: void 0,
			title: void 0
		},
		restrictedAccess: {
			actionLink: void 0,
			actionText: void 0,
			blockButton__emailSupport: void 0,
			blockButton__joinWaitlist: void 0,
			subtitle: void 0,
			subtitleWaitlist: void 0,
			title: void 0
		},
		start: {
			actionLink: "تسجيل الدخول",
			actionLink__use_email: void 0,
			actionLink__use_phone: void 0,
			actionText: "لديك حساب بالفعل؟",
			alternativePhoneCodeProvider: {
				actionLink: void 0,
				label: void 0,
				subtitle: void 0,
				title: void 0
			},
			subtitle: "للمتابعة إلى {{applicationName}}",
			subtitleCombined: void 0,
			title: "أنشاء حساب جديد",
			titleCombined: "أنشاء حساب جديد"
		},
		web3Solana: {
			subtitle: "حدد محفظة أدناه للتسجيل",
			title: "التسجيل باستخدام Solana"
		}
	},
	socialButtonsBlockButton: "للمتابعة مع {{provider|titleize}}",
	socialButtonsBlockButtonManyInView: "{{provider|titleize}}",
	taskChooseOrganization: {
		alerts: { organizationAlreadyExists: "توجد منظمة بالفعل لاسم الشركة المكتشف ({{organizationName}}) و {{organizationDomain}}. انضم عن طريق الدعوة." },
		chooseOrganization: {
			action__createOrganization: "إنشاء منظمة جديدة",
			action__invitationAccept: "انضم",
			action__suggestionsAccept: "طلب الانضمام",
			subtitle: "انضم إلى منظمة موجودة أو أنشئ واحدة جديدة",
			subtitle__createOrganizationDisabled: "انضم إلى منظمة موجودة",
			suggestionsAcceptedLabel: "في انتظار الموافقة",
			title: "اختر منظمة"
		},
		createOrganization: {
			formButtonReset: "إلغاء",
			formButtonSubmit: "متابعة",
			formFieldInputPlaceholder__name: "منظمتي",
			formFieldInputPlaceholder__slug: "munazzamati",
			formFieldLabel__name: "الاسم",
			formFieldLabel__slug: "Slug",
			subtitle: "أدخل تفاصيل منظمتك للمتابعة",
			title: "إعداد منظمتك"
		},
		organizationCreationDisabled: {
			subtitle: "تواصل مع مسؤول منظمتك للحصول على دعوة.",
			title: "يجب أن تنتمي إلى منظمة"
		},
		signOut: {
			actionLink: "تسجيل الخروج",
			actionText: "تم تسجيل الدخول كـ {{identifier}}"
		}
	},
	taskResetPassword: {
		formButtonPrimary: void 0,
		signOut: {
			actionLink: void 0,
			actionText: void 0
		},
		subtitle: void 0,
		title: void 0
	},
	taskSetupMfa: {
		badge: void 0,
		signOut: {
			actionLink: void 0,
			actionText: void 0
		},
		smsCode: {
			addPhone: {
				formButtonPrimary: void 0,
				infoText: void 0
			},
			addPhoneNumber: void 0,
			cancel: void 0,
			subtitle: void 0,
			success: {
				finishButton: void 0,
				message1: void 0,
				message2: void 0,
				title: void 0
			},
			title: void 0,
			verifyPhone: {
				formButtonPrimary: void 0,
				formTitle: void 0,
				resendButton: void 0,
				subtitle: void 0,
				title: void 0
			}
		},
		start: {
			methodSelection: {
				phoneCode: void 0,
				totp: void 0
			},
			subtitle: void 0,
			title: void 0
		},
		totpCode: {
			addAuthenticatorApp: {
				buttonAbleToScan__nonPrimary: void 0,
				buttonUnableToScan__nonPrimary: void 0,
				formButtonPrimary: void 0,
				formButtonReset: void 0,
				infoText__ableToScan: void 0,
				infoText__unableToScan: void 0,
				inputLabel__unableToScan1: void 0
			},
			success: {
				finishButton: void 0,
				message1: void 0,
				message2: void 0,
				title: void 0
			},
			title: void 0,
			verifyTotp: {
				formButtonPrimary: void 0,
				formButtonReset: void 0,
				formTitle: void 0,
				subtitle: void 0,
				title: void 0
			}
		}
	},
	unstable__errors: {
		action_blocked: void 0,
		already_a_member_in_organization: void 0,
		api_key_name_already_exists: void 0,
		api_key_usage_exceeded: void 0,
		avatar_file_size_exceeded: "حجم الملف يتجاوز الحد الأقصى البالغ 10 ميغابايت. يرجى اختيار ملف أصغر.",
		avatar_file_type_invalid: "نوع الملف غير مدعوم. يرجى تحميل صورة بصيغة JPG أو PNG أو GIF أو WEBP.",
		captcha_invalid: "لا يمكن تسجيل الحساب بسبب مشاكل تحقق أمنية. الرجاء تحديث الصفحة للمحاولة مرة أخرى أو تواصل معنا للمزيد من المساعدة",
		captcha_unavailable: "التسجيل غير ناجح بسبب فشل التحقق من صحة الروبوت. يُرجى تحديث الصفحة للمحاولة مرة أخرى أو التواصل مع فريق الدعم للحصول على مزيد من المساعدة",
		form_code_incorrect: void 0,
		form_email_address_blocked: "خدمات البريد الإلكتروني المؤقتة غير مدعومة. يرجى استخدام عنوان بريدك الإلكتروني العادي لإنشاء حساب.",
		form_identifier_exists__email_address: "تم إستخدام البريد الإلكتروني هذا. يرجى المحاولة مرة أخرى",
		form_identifier_exists__phone_number: "تم إستخدام رقم الهاتف هذا. يرجى المحاولة مرة أخرى",
		form_identifier_exists__username: "تم إستخدام اسم المستخدمد هذا. يرجى المحاولة مرة أخرى",
		form_identifier_not_found: "لم يتم العثور على حساب بهذه التفاصيل",
		form_new_password_matches_current: void 0,
		form_param_format_invalid: void 0,
		form_param_format_invalid__email_address: "يجب أستعمال بريد إلكتروني صالح",
		form_param_format_invalid__phone_number: "Phone number must be in a valid international format",
		form_param_max_length_exceeded__first_name: "الأسم الأول يجب الا يتجاوز 256 حرف",
		form_param_max_length_exceeded__last_name: "الأسم الأخير يجب الا يتجاوز 256 حرف",
		form_param_max_length_exceeded__name: "الأسم يجب الا يتجاوز 256 حرف",
		form_param_nil: void 0,
		form_param_type_invalid: void 0,
		form_param_type_invalid__email_address: void 0,
		form_param_type_invalid__phone_number: void 0,
		form_param_value_invalid: void 0,
		form_password_compromised__sign_in: void 0,
		form_password_incorrect: void 0,
		form_password_length_too_short: void 0,
		form_password_matches_identifier: void 0,
		form_password_not_strong_enough: "كلمة المرور ليست قوية",
		form_password_or_identifier_incorrect: "كلمة المرور أو عنوان البريد الإلكتروني غير صحيح. حاول مرة أخرى أو استخدم طريقة أخرى.",
		form_password_pwned: "لا يمكن أستعمال كلمة السر هذه لانها غير أمنة, الرجاء اختيار كلمة مرور أخرى",
		form_password_pwned__sign_in: "لا يمكن أستعمال كلمة السر هذه لانها غير أمنة, الرجاء اختيار كلمة مرور أخرى",
		form_password_size_in_bytes_exceeded: "تجاوزت كلمة المرور الحد الأقصى للحروف المدخلة, الرجاء أدخال كلمة مرور أقصر أو حذف بعض الأحرف الخاصة",
		form_password_untrusted__sign_in: void 0,
		form_password_validation_failed: "كلمة مرور خاطئة",
		form_username_invalid_character: void 0,
		form_username_invalid_length: void 0,
		form_username_needs_non_number_char: "يجب أن يحتوي اسم المستخدم على حرف واحد على الأقل غير رقمي.",
		identification_deletion_failed: "لا يمكن حذف هويتك الآخيرة ",
		insufficient_seats_change_plan: void 0,
		insufficient_seats_contact_support: void 0,
		not_allowed_access: "لا يُسمح بالتسجيل باستخدام عنوان البريد الإلكتروني أو رقم الهاتف. قد يكون ذلك بسبب استخدام \"+\" أو \"=\" أو \"#\" أو \".\" في عنوان بريدك الإلكتروني، أو استخدام نطاق متصل بخدمة بريد إلكتروني مؤقتة، أو حظرك بشكل صريح. إذا كنت تعتقد أن هذا خطأ، يُرجى التواصل مع الدعم.",
		oauth_access_denied: void 0,
		organization_domain_blocked: void 0,
		organization_domain_common: void 0,
		organization_domain_exists_for_enterprise_connection: void 0,
		organization_membership_quota_exceeded: void 0,
		organization_minimum_permissions_needed: void 0,
		organization_not_found_or_unauthorized: void 0,
		organization_not_found_or_unauthorized_with_create_organization_disabled: void 0,
		passkey_already_exists: "تم تسجيل مفتاح المرور مسبقاً مع هذا الجهاز",
		passkey_not_supported: "مفاتيح المرور غير مدعومة على هذا الجهاز",
		passkey_pa_not_supported: "يتطلب التسجيل أداة مصادقة النظام الأساسي ولكن الجهاز لا يدعمها",
		passkey_registration_cancelled: "تم إلغاء تسجيل مفتاح المرور أو انتهت مهلته",
		passkey_retrieval_cancelled: "تم إلغاء تسجيل مفتاح المرور أو انتهت مهلته",
		passwordComplexity: {
			maximumLength: "أقل من {{length}} حروف",
			minimumLength: "{{length}} حروف أو أكثر",
			requireLowercase: "حرف صغير",
			requireNumbers: "رقم",
			requireSpecialCharacter: "حرف خاص",
			requireUppercase: "حرف كبير",
			sentencePrefix: "كلمة السر يجب أن تحتوي على"
		},
		phone_number_exists: "هذا الرقم مأخوذ الرجاء أختيار رقم آخر",
		protect_check_aborted: void 0,
		protect_check_already_resolved: void 0,
		protect_check_execution_failed: void 0,
		protect_check_invalid_script: void 0,
		protect_check_invalid_sdk_url: void 0,
		protect_check_required: void 0,
		protect_check_script_load_failed: void 0,
		protect_check_timed_out: void 0,
		protect_check_unsupported_environment: void 0,
		session_exists: "لقد قمت بتسجيل الدخول بالفعل",
		sso_bypass_domain_not_served: void 0,
		ticket_expired_code: void 0,
		ticket_invalid_code: void 0,
		too_many_unverified_identifications: void 0,
		web3_missing_identifier: void 0,
		web3_signature_request_rejected: "لقد رفضت طلب التوقيع. يرجى المحاولة مرة أخرى للمتابعة.",
		web3_solana_signature_generation_failed: "حدث خطأ أثناء إنشاء التوقيع. يرجى المحاولة مرة أخرى للمتابعة.",
		zxcvbn: {
			couldBeStronger: "كلمة مرورك سليمة من الأفضل ان تكون اقوى. الرجاء أضافة حروف أكثر",
			goodPassword: "كلمة مرورك طابقت جميع المتطلبات الازمة",
			notEnough: "كلمة المرور ليست قوية",
			suggestions: {
				allUppercase: "أستعمل حروف كبيرة لبعض الحروف وليس كلها.",
				anotherWord: "أضف المزيد من الكلمات الأقل شيوعًا.",
				associatedYears: "تجنب السنوات المرتبطة بك.",
				capitalization: "أستعمل حروف كبيرة لأكثر من حرف غير الحرف الأول",
				dates: "تجنب التواريخ والسنوات المرتبطة بك.",
				l33t: "تجنب بدائل الحروف التي يمكن التنبؤ بها مثل \"a\" ل \"@\" ",
				longerKeyboardPattern: "أستخدم أنماط أكثر وقم بتغيير أتجاه الكتابة في لوحة المفاتيح عدة مرات",
				noNeed: "يمكنك إنشاء كلمات مرور قوية دون استخدام الرموز أو الأرقام أو الأحرف الكبيرة.",
				pwned: "إذا كنت تستخدم كلمة المرور هذه في مكان آخر ، فيجب عليك تغييرها.",
				recentYears: "تجنب السنوات الأخيرة.",
				repeated: "تجنب الكلمات والحروف المتكررة.",
				reverseWords: "تجنب التهجئات العكسية للكلمات الشائعة.",
				sequences: "تجنب تسلسل الأحرف الشائعة.",
				useWords: "استخدم كلمات متعددة ، ولكن تجنب العبارات الشائعة."
			},
			warnings: {
				common: "كلمة السر هذه شائعة في الأستخدام",
				commonNames: "من السهل تخمين الأسماء والألقاب الشائعة",
				dates: "من السهل تخمين التواريخ",
				extendedRepeat: "من السهل تخمين أنماط الحروف المتكررة مثل \"abcabcabc\"",
				keyPattern: "من السهل تخمين أنماط لوحة المفاتيح الصغيرة",
				namesByThemselves: "من السهل تخمين الأسم الأول أو اللقب",
				pwned: "كلمة المرور الخاص بك تم أختراقها والكشف عنها في الأنترنت",
				recentYears: "من السهل تخمين السنوات الحديثة",
				sequences: "من السهل تخمين أنماط الحروف العامة أو الهجائية مثل \"abc\" ",
				similarToCommon: "كلمة السر هذه مشابهة لكلمات السر الشائعة في الأستخدام",
				simpleRepeat: "من السهل تخمين الحروف المكررة مثل \"aaa\"",
				straightRow: "من السهل تخمين الحروف الموجودة على نفس السطر في لوحة المفاتيح",
				topHundred: "كلمة السر هذه مستخدمة بشكل متكررة",
				topTen: "كلمة السر هذه مستخدمة بكثرة",
				userInputs: "يجب ألا يكون هناك أي بيانات شخصية أو بيانات ذات صلة بالصفحة.",
				wordByItself: "من السهل تخميل الكلمات المنفردة"
			}
		}
	},
	userButton: {
		action__addAccount: "إضافة حساب",
		action__closeUserMenu: "إغلاق قائمة المستخدم",
		action__manageAccount: "إدارة الحساب",
		action__openUserMenu: "فتح قائمة المستخدم",
		action__signOut: "تسجيل الخروج",
		action__signOutAll: "تسجيل الخروج من جميع الحسابات",
		label__accountActions: "إجراءات الحساب",
		label__activeSessions: "الجلسات النشطة",
		label__userButtonPopover: "لوحة الحساب"
	},
	userProfile: {
		apiKeysPage: { title: void 0 },
		backupCodePage: {
			actionLabel__copied: "تم النسخ",
			actionLabel__copy: "نسخ الكل",
			actionLabel__download: "تحميل ملف .txt",
			actionLabel__print: "طباعة",
			infoText1: "سيتم تفعيل رموز النسخ الأحتياطي لهذا الحساب",
			infoText2: "قم بتخزين الرموز في مكان آمن وحافظ على سريتها. يمكنك تجديد الرموز الأحتياطية اذا كنت تشك أن حسابك معرض للخطر",
			subtitle__codelist: "قم بتخزين الرموز في مكان آمن وابقيها سرا.",
			successMessage: "رموز النسخ الأحتياطي مفعلة الآن. يمكنك أستعمال واحدة من هذه الرموز لتسجيل الدخول إلى حسابك, اذا فقدت الوصول إلى جهاز المصادقة الخاص بك. كل رمز يمكن أستعماله لمرة واحدة فقط.",
			successSubtitle: "يمكنك أستعمال واحدة من هذه الرموز لتسجيل الدخول إلى حسابك, اذا فقدت الوصول إلى جهاز المصادقة الخاص بك",
			title: "إضافة التحقق عن طريق الرموز الأحتياطية",
			title__codelist: "رموز النسخ الأحتياطي"
		},
		billingPage: {
			accountCreditsSection: {
				title: void 0,
				viewHistory: void 0
			},
			creditHistoryPage: {
				tableHeader__amount: void 0,
				tableHeader__date: void 0,
				title: void 0
			},
			paymentHistorySection: {
				empty: void 0,
				notFound: void 0,
				tableHeader__amount: void 0,
				tableHeader__date: void 0,
				tableHeader__status: void 0
			},
			paymentMethodsSection: {
				actionLabel__default: void 0,
				actionLabel__remove: void 0,
				add: void 0,
				addSubtitle: void 0,
				cancelButton: void 0,
				formButtonPrimary__add: void 0,
				formButtonPrimary__pay: void 0,
				payWithTestCardButton: void 0,
				removeMethod: {
					messageLine1: void 0,
					messageLine2: void 0,
					successMessage: void 0,
					title: void 0
				},
				title: void 0
			},
			start: {
				headerTitle__payments: void 0,
				headerTitle__plans: void 0,
				headerTitle__statements: void 0,
				headerTitle__subscriptions: void 0
			},
			statementsSection: {
				empty: void 0,
				itemCaption__paidForPlan: void 0,
				itemCaption__payerCredit: void 0,
				itemCaption__proratedCredit: void 0,
				itemCaption__subscribedAndPaidForPlan: void 0,
				notFound: void 0,
				tableHeader__amount: void 0,
				tableHeader__date: void 0,
				title: void 0,
				totalPaid: void 0
			},
			subscriptionsListSection: {
				actionLabel__manageSubscription: void 0,
				actionLabel__newSubscription: void 0,
				actionLabel__switchPlan: void 0,
				overview: void 0,
				tableHeader__edit: void 0,
				tableHeader__plan: void 0,
				tableHeader__startDate: void 0,
				title: void 0
			},
			subscriptionsSection: { actionLabel__default: void 0 },
			switchPlansSection: { title: void 0 },
			title: void 0
		},
		connectedAccountPage: {
			formHint: "أختر موفر خدمة لتوصيل حسابك",
			formHint__noAccounts: "لا يوجد موفرين خدمة لتوصيل حسابك",
			removeResource: {
				messageLine1: "سيتم حذف هذا الموفر من حسابك {{identifier}}",
				messageLine2: "لن تتمكن بعد الآن من استخدام هذا الحساب المتصل ولن تعمل أي ميزات تابعة.",
				successMessage: "تم حذف هذا العنوان من حسابك {{connectedAccount}}",
				title: "حذف الحساب المتصل"
			},
			socialButtonsBlockButton: "إضافة الموفر {{provider|titleize}} لحسابك",
			successMessage: "تمت إضافة موفر الخدمة الى حسابك",
			title: "أضف حساب متصل"
		},
		deletePage: {
			actionDescription: "أكتب حذف حساب بالأسفل للمتابعة",
			confirm: "حذف حساب",
			messageLine1: "هل أنت متأكد من رغبتك في حذف حسابك؟ قد يتم الاحتفاظ ببعض البيانات المرتبطة. لطلب حذف البيانات بالكامل، يرجى الاتصال بالدعم.",
			messageLine2: "هذا القرار نهائي ولا يمكن التراجع عنه.",
			title: "حذف الحساب"
		},
		emailAddressPage: {
			emailCode: {
				formHint: "سيتم إرسال بريد إلكتروني يحتوي على رمز التحقق لهذا البريد الإلكتروني",
				formSubtitle: "أرسل رمز التحقق المرسل إلى {{identifier}}",
				formTitle: "رمز التحقق",
				resendButton: "لم يصلك الرمز؟ حاول مرة أخرى",
				successMessage: "البريد الإلكتروني {{identifier}} تمت إضافته إلى حسابك"
			},
			emailLink: {
				formHint: "سيتم إرسال بريد إلكتروني يحتوي على رمز التحقق لهذا البريد الإلكتروني",
				formSubtitle: "أنقر على رابط التحقق المرسل إلى البريد الألكتروني {{identifier}}",
				formTitle: "رابط التحقق",
				resendButton: "لم يصلك الرابط؟ حاول مرة أخرى",
				successMessage: "البريد الإلكتروني {{identifier}} تمت إضافته إلى حسابك"
			},
			enterpriseSSOLink: {
				formButton: void 0,
				formSubtitle: void 0
			},
			formHint: void 0,
			removeResource: {
				messageLine1: "سيتم حذف هذا الإيميل من حسابك {{identifier}}",
				messageLine2: "لن تتمكن من تسجيل الدخول باستخدام عنوان البريد الإلكتروني هذا.",
				successMessage: "تم حذف هذا العنوان من حسابك {{emailAddress}}",
				title: "حذف عنوان البريد الإلكتروني هذا"
			},
			title: "أضافة البريد الإلكتروني",
			verifyTitle: "Verify email address"
		},
		formButtonPrimary__add: "إضافة",
		formButtonPrimary__continue: "متابعة",
		formButtonPrimary__finish: "انهاء",
		formButtonPrimary__remove: "إزالة",
		formButtonPrimary__save: "حفظ",
		formButtonReset: "الغاء",
		mfaPage: {
			formHint: "أختر طريقة للأضافة",
			title: "أضافة التحقق بخطوتين"
		},
		mfaPhoneCodePage: {
			backButton: "إستخدم الرقم الموجود",
			primaryButton__addPhoneNumber: "إضافة رقم جوال",
			removeResource: {
				messageLine1: "لن يتم إستلام اي رموز تحقق على {{identifier}} عند تسجيل الدخول",
				messageLine2: "قد لا يكون حسابك آمنا. هل أنك متأكد أنك تريد المتابعة؟",
				successMessage: "تم إلغاء التحقق بخطوتين عن طريق الرسائل النصية لرقم الجوال هذا {{mfaPhoneCode}}",
				title: "إزالة التحقق بخطوتين"
			},
			subtitle__availablePhoneNumbers: "أختر رقم جوال لأضافة التحقق بخطوتين عن طريق الرسائل النصية",
			subtitle__unavailablePhoneNumbers: "لا يوجد رقم جوال لأضافة التحقق بخطوتين عن طريق الرسائل النصية",
			successMessage1: "عند تسجيل الدخول، سوف تحتاج إلى إدخال رمز التحقق الذي تم إرساله إلى رقم الهاتف هذا كخطوة إضافية.",
			successMessage2: "احفظ هذه الرموز الاحتياطية وقم بتخزينها في مكان آمن.\" إذا فقدت إمكانية الوصول إلى جهاز المصادقة الخاص بك، فيمكنك استخدام الرموز الاحتياطية لتسجيل الدخول.",
			successTitle: "تم تمكين التحقق من رمز الرسائل القصيرة",
			title: "أضافة التحقق عن طريق رمز الرسائل النصية"
		},
		mfaTOTPPage: {
			authenticatorApp: {
				buttonAbleToScan__nonPrimary: "مسح رمز الQR بدلا من ذلك",
				buttonUnableToScan__nonPrimary: "لا يمكنك مسح رمز الQR?",
				infoText__ableToScan: "قم بإعداد طريقة تسجيل دخول جديدة في تطبيق المصادقة و قم بمسح كود الQR لربطه بحسابك",
				infoText__unableToScan: "قم بإعداد تسجيل دخول جديدة في تطبيق المصادقة وأدخل الرمز المقدم أدناه",
				inputLabel__unableToScan1: "تأكد من تفعيل كلمات المرور المستندة إلى الوقت أو الأستعمال الواحد, ثم أكمل ربط حسابك",
				inputLabel__unableToScan2: "بدلا من ذلك, إذا كان المصدق الخاص بك يدعم روابط المدعومة من طرق المستندة إلى الوقت أو الأستعمال الواحد, يمكنك نسخ الرابط كله"
			},
			removeResource: {
				messageLine1: "رموز التحقق من برنامج المصادقة هذا ستكون غير ضروية عند تسجيل الدخول",
				messageLine2: "قد لا يكون حسابك آمنا. هل أنك متأكد أنك تريد المتابعة؟",
				successMessage: "تم أزالة طريقة التحقق بخطوتين من تطبيق المصادقة",
				title: "إزالة التحقق بخطوتين"
			},
			successMessage: "تم تمكين التحقق بخطوتين اللآن. عند تسجيل الدخول سوف يطلب منك أدخال رمز التحقق من تطبيق المصادقة الخاص بك",
			title: "إضافة تطبيق مصادقة",
			verifySubtitle: "أدخل رمز التحقق المنشئ في تطبيق المصادقة",
			verifyTitle: "رمز التحقق"
		},
		mobileButton__menu: "القائمة",
		navbar: {
			account: "الملف الشخصي",
			apiKeys: void 0,
			billing: void 0,
			description: "إدارة معلومات ملفك الشخصي.",
			security: "حماية",
			title: "الملف الشخصي"
		},
		passkeyScreen: {
			removeResource: {
				messageLine1: "{{name}} سوف يتم حذفه من هذا الحساب.",
				title: "إزالة مفتاح المرور"
			},
			subtitle__rename: "يمكنك تغيير اسم مفتاح المرور لتسهيل العثور عليه",
			title__rename: "إعادة تسمية مفتاح المرور"
		},
		passwordPage: {
			checkboxInfoText__signOutOfOtherSessions: "يوصى بتسجيل الخروج من جميع الأجهزة الأخرى التي ربما قد استخدمت كلمة المرور القديمة الخاصة بك.",
			readonly: "لا يمكن تعديل كلمة المرور لأنه لا يمكنك تسجيل الدخول إلى عن طريق حساب المؤسسة",
			successMessage__set: "تم تعيين كلمة السر.",
			successMessage__signOutOfOtherSessions: "تم تسجيل الخروج من جميع الأجهزة.",
			successMessage__update: "تم تحديث كلمة السر",
			title__set: "تعيين كلمة المرور",
			title__update: "تغيير كلمة المرور"
		},
		phoneNumberPage: {
			infoText: "سيتم إرسال رسالة نصية تحتوي على رابط التحقق إلى رقم الهاتف هذا.",
			removeResource: {
				messageLine1: "سيتم حذف هذا الإيميل من حسابك {{identifier}}",
				messageLine2: "لن تتمكن من تسجيل الدخول بإستخدام رقم الجوال هذا",
				successMessage: "تم حذف هذا العنوان من حسابك {{phoneNumber}}",
				title: "حذف رقم الجوال"
			},
			successMessage: "تم إضافة رقم الجوال هذا {{identifier}}",
			title: "إضافة رقم جوال",
			verifySubtitle: "أدخل رمز التحقق المرسل إلى {{identifier}}",
			verifyTitle: "التحقق من رقم الهاتف"
		},
		plansPage: { title: void 0 },
		profilePage: {
			fileDropAreaHint: "أرفع صورة بصيغة JPG, PNG, GIF أو WEBP أقل من 10 ميغابايت",
			imageFormDestructiveActionSubtitle: "حذف صورة الملف الشخصي",
			imageFormSubtitle: "رفع صورة للملف الشخصي",
			imageFormTitle: "صورة الملف الشخصي",
			readonly: "تم توفير معلومات حسابك عن طريق حساب المؤسسة ولا يمكن تعديلها",
			successMessage: "معلومات حسابك الشخصي تم تحديثها",
			title: "تحديث الملف الشخصي"
		},
		start: {
			activeDevicesSection: {
				destructiveAction: "قم بتسجيل الخروج من الجهاز",
				title: "الأجهزة النشطة"
			},
			connectedAccountsSection: {
				actionLabel__connectionFailed: "حاول مرة أخرى",
				actionLabel__reauthorize: "أعطى الصلاحية الآن",
				destructiveActionTitle: "حذف",
				primaryButton: "ربط حساب",
				subtitle__disconnected: void 0,
				subtitle__reauthorize: "تم تحديث النطاقات المطلوبة. هذا التحديث قد يحد من العمليات الوظيفية. يرجى إعادة ترخيص هذا التطبيق لتجنب أي مشاكل",
				title: "الحسابات المتصلة"
			},
			dangerSection: {
				deleteAccountButton: "حذف الحساب",
				title: "خطر"
			},
			emailAddressesSection: {
				destructiveAction: "أحذف البريد الإلكتروني",
				detailsAction__nonPrimary: "تعيين كبريد رئيسي",
				detailsAction__primary: "التحقق الكامل",
				detailsAction__unverified: "تحقق من البريد الإلكتروني",
				primaryButton: "أضافة عنوان إلكتروني",
				title: "العنوان الإلكتروني"
			},
			enterpriseAccountsSection: {
				primaryButton: "ربط حساب",
				title: "حساب المؤسسات"
			},
			headerTitle__account: "الحساب",
			headerTitle__security: "الأمان",
			mfaSection: {
				backupCodes: {
					actionLabel__regenerate: "تجديد رموز النسخ الاحتياطي",
					headerTitle: "رموز النسخ الاحتياطي",
					subtitle__regenerate: "احصل على مجموعة جديدة من رموز النسخ الاحتياطي الآمنة. سيتم حذف رموز النسخ الاحتياطي السابقة ولا يمكن استخدامها.",
					title__regenerate: "تجديد رموز النسخ الاحتياطي"
				},
				phoneCode: {
					actionLabel__setDefault: "تعيين كأفتراضي",
					destructiveActionLabel: "حذف رقم الجوال"
				},
				primaryButton: "إضافةالتحقق بخطوتين",
				title: "التحقق بخطوتين",
				totp: {
					destructiveActionTitle: "حذف",
					headerTitle: "تطبيق المصادقة"
				}
			},
			passkeysSection: {
				menuAction__destructive: "إزالة",
				menuAction__rename: "إعادة تسمية",
				primaryButton: void 0,
				title: "مفاتيح المرور"
			},
			passwordSection: {
				primaryButton__setPassword: "تعيين كلمة المرور",
				primaryButton__updatePassword: "تغيير كلمة المرور",
				title: "كلمة المرور"
			},
			phoneNumbersSection: {
				destructiveAction: "حذف رقم الجوال",
				detailsAction__nonPrimary: "تعيين كرئيسي",
				detailsAction__primary: "التحقق الكامل",
				detailsAction__unverified: "تحقق من رقم الجوال",
				primaryButton: "إضافة رقم جوال",
				title: "رقم الجوال"
			},
			profileSection: {
				primaryButton: "تحديث الملف الشخصي",
				title: "الملف الشخصي"
			},
			usernameSection: {
				primaryButton__setUsername: "تعيين اسم المستخدم",
				primaryButton__updateUsername: "تغيير اسم المستخدم",
				title: "اسم المستخدم"
			},
			web3WalletsSection: {
				destructiveAction: "حذف المحفظة",
				detailsAction__nonPrimary: void 0,
				primaryButton: "محافظ Web3",
				title: "محافظ Web3",
				web3SelectSolanaWalletScreen: {
					subtitle: "حدد محفظة Solana للاتصال بحسابك.",
					title: "إضافة محفظة Solana"
				}
			}
		},
		usernamePage: {
			successMessage: "تم تحديث اسم المستخدم",
			title__set: "تحديث اسم المستخدم",
			title__update: "تحديث اسم المستخدم"
		},
		web3WalletPage: {
			removeResource: {
				messageLine1: "سيتم حذف هذه المحفظة من حسابك{{identifier}}",
				messageLine2: "لن تتمكن من تسجيل الدخول إلى الحساب بإستخدام محفظة web3 هذه",
				successMessage: "تم حذف هذه المحفظة من حسابك{{web3Wallet}}",
				title: "حذف محفظة web3"
			},
			subtitle__availableWallets: "أختر محفظة web3 لتوصيلها بحسابك",
			subtitle__unavailableWallets: "لا توجد اي محفظة web3 متاحة",
			successMessage: "تمت إضافة المحفظة الى حسابك.",
			title: "إضافة محفظة web3",
			web3WalletButtonsBlockButton: void 0
		}
	},
	waitlist: {
		start: {
			actionLink: "تسجيل الدخول",
			actionText: "هل لديك وصول بالفعل؟",
			formButton: "الانضمام إلى قائمة الانتظار",
			subtitle: "أدخل عنوان بريدك الإلكتروني وسنخبرك عندما يكون مكانك جاهزًا",
			title: "الانضمام إلى قائمة الانتظار"
		},
		success: {
			message: "سيتم إعادة توجيهك قريبًا...",
			subtitle: "سنكون على اتصال عندما يكون مكانك جاهزًا",
			title: "شكرًا للانضمام إلى قائمة الانتظار!"
		}
	},
	web3SolanaWalletButtons: {
		connect: "الاتصال باستخدام {{walletName}}",
		continue: "المتابعة باستخدام {{walletName}}",
		noneAvailable: "لم يتم اكتشاف محافظ Solana Web3. يرجى تثبيت {{ solanaWalletsLink || link(\"wallet extension\") }} مدعوم بـ Web3."
	}
};

//#endregion
export { arSA };
